import { useMemo } from "react";
import { get as lodashGet } from "lodash-es";
import { removeBracketsAndAppendDash } from "../utils/helper";
import type { OptionItem } from "@certa/types";
import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";
import type { InstanceConfiguration } from "@certa/queries/types/config.types";

export const useGetSupportedLanguages = () => {
  const { data: config } = useInstanceConfigQuery();
  const supportedLanguages = lodashGet(
    config,
    "supported_languages_json",
    {} as InstanceConfiguration["supported_languages_json"]
  );

  return useMemo(
    () =>
      Object.keys(supportedLanguages).map(languageCode => ({
        value: languageCode,
        label: `${removeBracketsAndAppendDash(
          supportedLanguages[languageCode]
        )} (${languageCode})`
      })) as OptionItem[],
    [supportedLanguages]
  );
};
